import React from 'react';
import T from 'prop-types';
import { formatTimeWholeSeconds } from 'shared/helpers/time';

const NUMBER_OF_VERTICAL_LINES = 25;
const NUMBER_OF_VERTICAL_SPACES = NUMBER_OF_VERTICAL_LINES - 1;
const LINE_WIDTH = 2;
const WIDTH_OF_TWO_LINES = 2 * LINE_WIDTH;

export default class Ruler extends React.PureComponent {
  getTimePositionForLine = ordinal => {
    const distanceInSeconds = this.props.episodeDuration / NUMBER_OF_VERTICAL_SPACES;
    return Math.floor(distanceInSeconds * ordinal);
  };

  getPixelPositionForLine = ordinal => {
    const roomForLines = this.props.timelineWidth - WIDTH_OF_TWO_LINES;
    const distanceInPixels = roomForLines / NUMBER_OF_VERTICAL_SPACES;
    return Math.floor(distanceInPixels * ordinal);
  };

  getTimeAndPixelPositionForLine = ordinal => ({
    time: this.getTimePositionForLine(ordinal),
    pixel: this.getPixelPositionForLine(ordinal),
  });

  renderVerticalLine({ time, pixel }) {
    return (
      <div
        key={pixel}
        className="editor-timeline__ruler__line--vertical"
        style={{ left: `${pixel}px` }}
      >
        <span className="editor-timeline__ruler__line--vertical__timestamp">
          {formatTimeWholeSeconds(time)}
        </span>
      </div>
    );
  }

  renderVerticalLines() {
    const linePositions = [];
    for (let i = 0; i < NUMBER_OF_VERTICAL_LINES; i++) {
      linePositions.push(this.getTimeAndPixelPositionForLine(i));
    }
    return <div>{linePositions.map(this.renderVerticalLine)}</div>;
  }

  renderHorizontalLine() {
    return <div className="editor-timeline__ruler__line--horizontal" />;
  }

  render() {
    return (
      <div className="editor-timeline__ruler">
        {this.renderVerticalLines()}
        {this.renderHorizontalLine()}
      </div>
    );
  }
}

Ruler.defaultProps = {
  episodeDuration: 0,
};

Ruler.propTypes = {
  timelineWidth: T.number.isRequired,
  episodeDuration: T.number,
};
